{
  "source": "CLDR 48.0 (ICU 78.2) via scripts/gen-work-week.mjs",
  "weekends": {
    "IR": [5],
    "AF": [4,5],
    "DZ": [5,6],
    "BH": [5,6],
    "EG": [5,6],
    "IN": [7],
    "IQ": [5,6],
    "JO": [5,6],
    "KW": [5,6],
    "LY": [5,6],
    "OM": [5,6],
    "QA": [5,6],
    "SA": [5,6],
    "SD": [5,6],
    "SY": [5,6],
    "YE": [5,6]
  }
}
